import * as React from 'react';

import Layout from '../../components/Layout/index';

import './style.scss';
import TitleBar from '../../components/TitleBar';

const PrivacyPolicyPage = () => {
  return (
    <Layout pageTitle="Privacy Policy">
      <TitleBar title="Privacy Policy" />
      <section className="l-generic-content">
        <article className="container">
          <aside>Last updated: April 28, 2020</aside>
          <main>
            <h2>The Professional Standards Council</h2>
            <p>
              This Privacy Policy is for the Professional Standards Councils and its agency the Professional Standards
              Authority, a business unit within the NSW Department of Finance, Services and Innovation established under
              a States and Territories Interdepartmental Agreement.
            </p>
            <p>
              Except where otherwise indicated, in this Privacy Policy, the terms “we”, “our” and “us” are used
              interchangeably to refer to the State of NSW through the Department of Finance, Services and Innovation,
              the Professional Standards Councils and the Professional Standards Authority.
            </p>
            <p>
              We are committed to protecting your privacy. Occupational associations and all our other stakeholders are
              entitled to expect that the information which they provide will be treated within the terms of relevant
              privacy responsibilities.
            </p>
            <p>
              As a business unit of the NSW Department of Finance, Services and Innovation, the Professional Standards
              Authority deals with personal information in accordance with the overarching Privacy Management Plan of
              the NSW Department of Finance, Services and Innovation and in accordance with the Privacy and Personal
              Information Protection Act (NSW) and the Health Records and Information Privacy Act 2002 (NSW). However,
              with regards to the collection of personal information through the Professional Standards Councils
              Website, the content of this Privacy Policy applies. For more information about your right to privacy,
              please visit the website of the NSW Information and Privacy Commission: www.ipc.nsw.gov.au
            </p>
            <h3>
              Collecting information through the Professional Standards Councils Website
            </h3>
            <h4>
              When do we collect information from you?
            </h4>
            <p>
              When we collect personal information from you through our Professional Standards Councils Website, we include privacy collection statements for your information. These privacy collection statements set out the way we may collect, use and disclose your information.  From time to time, we may include other privacy collection statements on our Professional Standards Councils Website, as they are approved by us from time to time. Please read the applicable privacy collection statement at the point where you provide to us your personal information.
            </p>
            <p>
              When you visit the Professional Standards Website, we may automatically collect information which identifies, for each page you visit on the website, the IP (Internet Protocol) address of the machine used to access that page. To improve the services provided by us, we may extract and publish aggregated information about usage patterns from these records. For example, usage reports may examine trends based on the following information – your server address, your top-level domain name (for example .com, .gov, .au, .uk etc), the date and time of visit to the site, the pages accessed and documents downloaded, the previous site visited, the type of browser used and operating system.
            </p>
            <h4>
              What do we collect when you email us directly?
            </h4>
            <p>
              When you provide us with your email address, either as part of an application or submission online, or when you email us via the ‘Contact us’ option on the Professional Standards Councils Website, we will: 
            </p>
            <ul>
              <li>
                record your email address and any other information submitted;
              </li>
              <li>
                use this information for the purpose for which you provide it; and
              </li>
              <li>
                not add your email address to a mailing list, unless provided by you specifically for that purpose. 
              </li>
            </ul>
            <h4>
              What we won’t do with the data we collect
            </h4>
            <p>
              We will not disclose or publish information that identifies individuals, individual machines, or potentially identifies sub-groupings of addresses, without consent or as otherwise required or permitted by law.
            </p>
            <h4>
              What exceptions are there to this rule?
            </h4>
            <p>
              We, or our third party hosting provider, will gather more extensive information than stated above in the following circumstances: 
            </p>
            <ul>
              <li>
                unauthorised attempts to access files which are not published on our Professional Standards Councils Website;
              </li>
              <li>
                unauthorised tampering or interference with files published on our Professional Standards Councils Website;
              </li>
              <li>
                unauthorised attempts to index the contents of our Professional Standards Councils Website by other Professional Standards Councils Websites;
              </li>
              <li>
                attempts to intercept messages of other users;
              </li>
              <li>
                communications which are defamatory, abusive, vilify individuals or groups or which give rise to a suspicion that an offence is being committed; or
              </li>
              <li>
                attempts to otherwise compromise the security of the web server, breach the laws of the State of New South Wales or Commonwealth of Australia, or interfere with the enjoyment of our Professional Standards Councils Website by other users.
              </li>
            </ul>
            <h4>
              Who accesses your data when you submit personal information through the Professional Standards Councils Website?
            </h4>
            <p>
              Access to this information is restricted to a limited number of officers in the Professional Standards Authority. This may include: 
            </p>
            <ul>
              <li>Executive Director</li>
              <li>Senior Marketing and Stakeholder Communications Officer</li>
              <li>Administrative Officer</li>
            </ul>
            <p>
              Personal information may also be seen by members of the Professional Standards Councils and / or Committees.
            </p>
            <p>
              We use third party service providers to design, develop and host our Professional Standards Councils Website and to provide us with ongoing support and maintenance. We have a right to disclose this data to any third party we have engaged for these purposes. We request that our service providers protect your privacy and not disclose personal information to anyone without contacting us first.
            </p>
            <p>
              We may be required to make disclosures to relevant authorities where the use of our Professional Standards Councils Website raises a suspicion that an offence is being, or has been, committed. In the event of an investigation, the Professional Standards Councils will provide access to personal information to any law enforcement agency that may exercise a warrant to inspect our logs. 
            </p>
            <h4>
              Is the raw data stored in a secure way?
            </h4>
            <p>
              Yes. The raw information collected is stored in a secure format. This applies to the raw information collected through our Professional Standards Councils Website and which is held by our hosting service provider.
            </p>
            <p>
              It is possible that raw information will be stored overseas in the event that our third party hosting provider utilises cloud technology for the storage of personal information.
            </p>
            <p>
              We request that all our service providers store your personal information in accordance with terms that are consistent with our own privacy obligations. We also have access to this information for archival purposes.
            </p>
            <h4>
              Application of our Privacy Policy
            </h4>
            <p>
              We are not responsible for, and make no representations or warranties in relation to the privacy practices of other third party websites that are linked to from our Professional Standards Councils Website. This privacy policy only applies to the information that is collected by the Professional Standards Councils either from you in person or through our Professional Standards Councils’ Website. We encourage you to read the privacy policies of other third parties that you may be referred to or that you may link to from our Professional Standards Councils Website.
            </p>
            <p>
              If you would like to know more about how the Professional Standards Councils collects and handles your personal information, if you have a complaint about our handling of your personal information or you would like to access or correct the personal information you’ve given to us, please contact our agency at pscinfo@psc.gov.au or 1300 555 772.
            </p>
            <h4>
              Changes to our Privacy Policy
            </h4>
            <p>
              Due to the developing nature of privacy principles for online communication, this policy may be modified or expanded in light of new developments or issues that may arise from time to time. We would be pleased to receive any comments or suggestions on this policy.
            </p>
          </main>
        </article>
      </section>
    </Layout>
  );
};

export default PrivacyPolicyPage;
